import { MutationTree } from 'vuex';
import { State } from '@/stores/customers/state';
import { Customer } from '@/models/customer';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setCustomers = (state: State, customers: Array<Customer>) => {
        state.customers = customers;
    }
    public setContactNames = (state: State, contactNames: Array<string>) => {
        state.contactNames = contactNames;
    }
}
